import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { AiFillPlusCircle, AiFillMinusCircle } from 'react-icons/ai';

import Skeleton from "react-loading-skeleton";
import DataTable from "../../../components/Datatable/DataTable";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import Button from "../../../components/Button/Button";
import DateTimePicker from "../../../components/DateTimePicker/DateTimePicker";
import Select from "../../../components/Input/Select/Select";

class EventMatchListing extends Component {
    /* ============ Component Lifecycle [START] ============ */
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }
    /* ============ Component Lifecycle [END] ============ */

    render() {
        const { t } = this.props;
        let rsListing = [];
        
        /* ======================== datatables data assign [START] ======================== */
        const columns = [
            {
                text: t("event_match.no"),
                dataField: "no",
                formatter: this.props.noFormatter,
                headerStyle: { width: "60px", textAlign: "center" },
            },
            {
                text: t("event_match.match_date"),
                dataField: "match_date",
                sort: true,
                onSort: this.props.onSort
            },
            {
                text: t("event_match.league"),
                dataField: "league",
                sort: false,
            },
            {
                text: t("event_match.slug"),
                dataField: "slug",
                sort: false,
            },
            {
                text: t("event_match.team_a"),
                dataField: "team_a",
                sort: false,
            },
            {
                text: t("event_match.team_b"),
                dataField: "team_b",
                sort: false,
            },
            {
                text: t("event_match.team_a_score"),
                dataField: "team_a_score",
                sort: false,
            },
            {
                text: t("event_match.team_b_score"),
                dataField: "team_b_score",
                sort: false,
            },
            {
                text: t("event_match.status"),
                dataField: "status",
                formatter:this.props.statusFormatter,
                sort: false,
            },
            {
                text: t("event_match.extra_status"),
                dataField: "extra_status",
                sort: false,
            },
            {
                text: t("event_match.team_a_extra_score"),
                dataField: "team_a_extra_score",
                sort: false,
            },
            {
                text: t("event_match.team_b_extra_score"),
                dataField: "team_b_extra_score",
                sort: false,
            },
            {
                text: t("event_match.update_date"),
                dataField: "update_date",
                sort: true,
                onSort: this.props.onSort
            },
            {
                text: t("global.action"),
                dataField: "#",
                formatter: this.props.actionFormatter,
                headerStyle: { width: "120px" },
                hidden: (this.props.permission.includes("match_event_update") || this.props.permission.includes("match_event_update_score")) ? false : true,
            },
        ];
        
        if (this.props.data) {
            rsListing = this.props.data.map((val, idx) => {
                let extraStatus = '-';
                if (val.is_extra === 1) {
                    extraStatus = t('event_match.extra_time');
                } else if (val.is_extra === 2) {
                    extraStatus = t('event_match.penalty');
                }

                return {
                    match_id: val.id,
                    no: idx+1,
                    match_date: val.match_date,
                    league: t('world_cup.'+val.league_slug),
                    slug: !!(val.slug) ? t('world_cup.'+val.slug) : '-',
                    team_a: t('world_cup.'+val.team_a_slug),
                    team_b: t('world_cup.'+val.team_b_slug),
                    team_a_score: val.team_a_score,
                    team_b_score: val.team_b_score,
                    status: val.status,
                    extra_status: extraStatus,
                    team_a_extra_score: val.team_a_extra_score,
                    team_b_extra_score: val.team_b_extra_score,
                    update_date: val.update_date,
                };
            });
        }

        return (
            <Auxiliary>
                <div className="row row-sm">
                    <div className="breadcrumb-header justify-content-between">
                        <div className="my-auto">
                            <div className="d-flex">
                                <h4 className="content-title mb-0 my-auto text-muted mt-1 tx-13 ml-2 mb-0">{t("event_match.event_match")}</h4>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-12">
                        <div className="card card-body">
                            <div className="col mt-auto">
                                {this.props.loading ? (
                                    <Skeleton count={2} />
                                ) : (
                            <div
                            className={`form-horizontal filter-function row
                            ${this.state.showCard?'open':'close'} filter-wrapper-1`}>
                                <div className="col-md-4 col-6">
                                    <div className="form-group">
                                        <label className="font-weight-bolder">
                                            {t("event_match.match_date")}
                                        </label>
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="fas fa-calendar-check" />
                                            </span>
                                            <DateTimePicker
                                                id="date"
                                                name="date"
                                                className="form-control filter-input"
                                                range={true}
                                                timePicker={true}
                                                value={this.props.filter.date}
                                                onChange={this.props.onInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-6">
                                    <div className="form-group">
                                        <label className="font-weight-bolder">
                                            {t("event_match.league")}
                                        </label>
                                        <Select
                                            id="league"
                                            name="league"
                                            className="form-control filter-input"
                                            onChange={this.props.onInputChange}
                                            options={this.props.dropdown.league}
                                            emptyValue={true}
                                            defaultValue={this.props.filter.league}                                            
                                        />
                                    </div>
                                </div>
                                {!!(this.props.filter.league) && (<div className="col-md-4 col-6">
                                    <div className="form-group">
                                        <label className="font-weight-bolder">
                                            {t("event_match.team")}
                                        </label>
                                        <Select
                                            id="team"
                                            name="team"
                                            className="form-control filter-input"
                                            onChange={this.props.onInputChange}
                                            options={this.props.dropdown.team}
                                            emptyValue={true}
                                            defaultValue={this.props.filter.team}                                            
                                        />
                                    </div>
                                </div>)}
                                <div className="col mt-auto">
                                    <div>
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-blue"
                                        idValue="filter"
                                        buttonName={t("global.filter")}
                                        clicked={() =>
                                            this.props.refreshHandler()
                                        }
                                    />
                                    &nbsp;
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-secondary"
                                        idValue="reset"
                                        buttonName={t("global.reset")}
                                        clicked={() =>
                                            this.props.clearHandler()
                                        }
                                    />
                                    </div>
                                </div>

                            </div>
                                    )}
                                </div>

                            <div className="show-btn"
                            onClick={()=>this.toggleCard()}>
                                {
                                    this.state.showCard? <AiFillMinusCircle/> : <AiFillPlusCircle/>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="d-flex align-items-end">
                                <div className="card-header pb-0">
                                    <div className="d-flex justify-content-between">
                                        <h4 className="card-title mg-b-0">
                                            {t("event_match.event_match_listing")}
                                        </h4>
                                    </div>
                                </div>
                                {this.props.permission.includes("match_event_create") && (
                                    <div className="d-flex">
                                        <div>
                                            <div className="btn-group">
                                                <AiFillPlusCircle />
                                                <Button
                                                    typeButton="button"
                                                    idValue="event_match"
                                                    classValue="btn btn-underline"
                                                    clicked={() => this.props.changePageHandler("create")}
                                                    buttonName={t("event_match.create_match")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="card-body">
                                <div className="table-responsive table-hover datatable">
                                    <DataTable
                                        keyField="no"
                                        data={rsListing}
                                        columns={columns}
                                        activePage={this.props.activePage}
                                        limit={this.props.limit}
                                        totalItems={this.props.totalRecords}
                                        paginationHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "activePage"
                                            )
                                        }
                                        sizePerPageHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "limit"
                                            )
                                        }
                                        searchChangeHandler={(val) =>
                                            this.props.datatablesChangeHandler(
                                                val,
                                                "searchValue"
                                            )
                                        }
                                        searchValue={this.props.searchValue}
                                        hideSearchBar={true}
                                        classValue="dataTable table-bordered text-justify text-center"
                                        loading={this.props.loading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

export default withNamespaces("translation")(EventMatchListing);
